import React from 'react'
import { Key, User, Bell, Shield } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function SettingsPage() {
  const { user } = useAuth()

  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600">
          Manage your account and platform preferences
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Profile Settings */}
        <div className="bg-white shadow rounded-lg p-6">
          <div className="flex items-center space-x-3 mb-4">
            <User className="h-6 w-6 text-gray-400" />
            <h3 className="text-lg font-medium text-gray-900">Profile</h3>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Username</label>
              <input
                type="text"
                value={user?.username || ''}
                disabled
                className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50 text-gray-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                value={user?.email || ''}
                disabled
                className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50 text-gray-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Role</label>
              <input
                type="text"
                value={user?.role || ''}
                disabled
                className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50 text-gray-500"
              />
            </div>
          </div>
        </div>

        {/* API Keys */}
        <div className="bg-white shadow rounded-lg p-6">
          <div className="flex items-center space-x-3 mb-4">
            <Key className="h-6 w-6 text-gray-400" />
            <h3 className="text-lg font-medium text-gray-900">API Keys</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Manage API keys for programmatic access to the platform.
          </p>
          <button className="w-full bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700">
            Generate New API Key
          </button>
        </div>

        {/* Security */}
        <div className="bg-white shadow rounded-lg p-6">
          <div className="flex items-center space-x-3 mb-4">
            <Shield className="h-6 w-6 text-gray-400" />
            <h3 className="text-lg font-medium text-gray-900">Security</h3>
          </div>
          <div className="space-y-3">
            <button className="w-full text-left border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-50">
              Change Password
            </button>
            <button className="w-full text-left border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-50">
              Two-Factor Authentication
            </button>
            <button className="w-full text-left border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-50">
              Active Sessions
            </button>
          </div>
        </div>
      </div>

      {/* Notifications */}
      <div className="mt-6 bg-white shadow rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-4">
          <Bell className="h-6 w-6 text-gray-400" />
          <h3 className="text-lg font-medium text-gray-900">Notifications</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-900">New Indicators</p>
              <p className="text-sm text-gray-600">Alert when new threats are detected</p>
            </div>
            <input type="checkbox" className="h-4 w-4 text-primary-600 border-gray-300 rounded" />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-900">Feed Updates</p>
              <p className="text-sm text-gray-600">Notify on feed polling results</p>
            </div>
            <input type="checkbox" className="h-4 w-4 text-primary-600 border-gray-300 rounded" />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-900">System Alerts</p>
              <p className="text-sm text-gray-600">Platform health and errors</p>
            </div>
            <input type="checkbox" className="h-4 w-4 text-primary-600 border-gray-300 rounded" defaultChecked />
          </div>
        </div>
      </div>
    </div>
  )
}